import { render, staticRenderFns } from "./CoverageInfo.vue?vue&type=template&id=239c649e&scoped=true&"
import script from "./CoverageInfo.vue?vue&type=script&lang=js&"
export * from "./CoverageInfo.vue?vue&type=script&lang=js&"
import style0 from "./CoverageInfo.vue?vue&type=style&index=0&id=239c649e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c649e",
  null
  
)

export default component.exports